/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_EmptyInputs */

const cs_requirements_empty = /** @type {(inputs: Requirements_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento klient nemá poptávky.`)
};

const en_requirements_empty = /** @type {(inputs: Requirements_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No requirements on this client.`)
};

/**
* | output |
* | --- |
* | "No requirements on this client." |
*
* @param {Requirements_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_empty = /** @type {((inputs?: Requirements_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_empty(inputs)
	return cs_requirements_empty(inputs)
});